import { render, staticRenderFns } from "./RecordListConfigurator.vue?vue&type=template&id=04c24ec9&"
import script from "./RecordListConfigurator.vue?vue&type=script&lang=js&"
export * from "./RecordListConfigurator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports